/**
 * @generated SignedSource<<d6df37037fbf8f56e6a0c6c39199cd8f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamScheduleAdminItemMonthDayIndicator_RoutineScheduleMonthly$data = {
  readonly endDay: number | null;
  readonly startDay: number;
  readonly " $fragmentType": "TeamScheduleAdminItemMonthDayIndicator_RoutineScheduleMonthly";
};
export type TeamScheduleAdminItemMonthDayIndicator_RoutineScheduleMonthly$key = {
  readonly " $data"?: TeamScheduleAdminItemMonthDayIndicator_RoutineScheduleMonthly$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleAdminItemMonthDayIndicator_RoutineScheduleMonthly">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamScheduleAdminItemMonthDayIndicator_RoutineScheduleMonthly",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startDay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endDay",
      "storageKey": null
    }
  ],
  "type": "RoutineScheduleMonthly",
  "abstractKey": null
};

(node as any).hash = "c2603c1a57fa6ccdd7d7ddbb7132244c";

export default node;
